<div class="card">
  <div class="card-header">
    <p class="title">{{ heading }}</p>
    <img 
      src='/assets/icons/summary/info-circle.svg' 
      alt="info"
      [matTooltip]="tooltip"
      matTooltipPosition="after"
      (mouseenter)="onInfoHover()"
      style="cursor: pointer;"
    />
  </div>
  <div class="horizontal-line"></div>
  <div class="card-content">
    <ng-content></ng-content>
  </div>
</div>